import { useFetch } from '@hooks/useFetch';
import { Link, Button } from '@mui/material';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import { useAlert } from '@hooks/useAlert';

// Use prod if not running local dev
const UPDATES_URL = import.meta.env.VITE_MO_UPDATES_URI;

export const DownloadModels = () => {
    const { setAlert } = useAlert();

    const { data } = useFetch({
        defaultValue: { count: 0, csv: '' },
        async fetcher() {
            const res = await fetch(new URL('data/models.json', UPDATES_URL));

            return (await res.json()) as { count: number; csv: string };
        },
        modifier(data) {
            return {
                ...data,
                // ? Convert to a downloadable CSV link
                csv: `data:text/csv;base64,${btoa(unescape(encodeURIComponent(data.csv)))}`,
            };
        },
        errorHandler() {
            setAlert('Failed to retrieve list of models.', 'error');
        },
    });

    return (
        <Button
            startIcon={<CloudDownloadIcon />}
            disabled={!data.count}
            component={Link}
            download={`${data.count}-models.csv`}
            href={data.csv}>
            RapidCut Models {Boolean(data.count) && `(${data.count})`}
        </Button>
    );
};
